import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environments';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private notificationsBaseUrl = environment.notificationsBaseUrl;

  constructor(
    private http: HttpClient
  ) {}

  sendErrorNotification(text: string, request: any, context?: string): Observable<any> {
      const params = request.body ? request.body : request.params;
      const url = request.urlWithParams;
      return this.http.post<any>(`${this.notificationsBaseUrl}/sendNotification`, { text, params, url, context });
    }
}
